import type { z } from 'zod';
import { z as zod } from 'zod';

/**
 * An optional string the model may hand back as "" when it has nothing to say. The empty string is
 * read as the field being absent, so a schema with a length floor does not reject the whole payload
 * over a blank the model meant as "none".
 */
export const emptyAsAbsent = <T extends z.ZodType<string>>(schema: T) =>
  zod.preprocess((value) => (value === '' ? undefined : value), schema.optional());
